/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { Container, FlexContainer, Stack, Text, H3, ArrowLink } from "@carrotfertility/carotene"
import { RetinaImage } from "../RetinaImage"
import { FormattedMessage } from "react-intl"

export function HomepageHelp(): JSX.Element {
  return (
    <FlexContainer
      background="lightGrey"
      direction="row"
      padding={["24px 32px", null, null, "24px 66px"]}
      alignItems="center"
      borderRadius="8px"
    >
      <Container minWidth={["0", null, null, "168px"]} width={["0", null, null, "168px"]}>
        <RetinaImage name={"conversations"} height={120} width={120} />
      </Container>
      <Container>
        <Stack spacing="tiny">
          <H3>
            <FormattedMessage defaultMessage="Can we help?" />
          </H3>
          <Text>
            <FormattedMessage defaultMessage="If you have questions about finding the right provider, how to advocate for yourself, or anything else, reach out to the Care Team." />
          </Text>
          <Container alignItems="center">
            <ArrowLink to="/talk-to-carrot/sendmessage/helpfindingprovider">
              <FormattedMessage defaultMessage="Contact Us" />
            </ArrowLink>
          </Container>
        </Stack>
      </Container>
    </FlexContainer>
  )
}
